import { render, staticRenderFns } from "./viewPointerMenu.vue?vue&type=template&id=077dc70e&scoped=true&"
import script from "./viewPointerMenu.vue?vue&type=script&lang=js&"
export * from "./viewPointerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077dc70e",
  null
  
)

export default component.exports